const formatVehicleLocation = (extItem, locationIds = []) => {
  const locationString = locationIds == null ? void 0 : locationIds.reduce((acc, locationId) => {
    var _a;
    const location = (_a = extItem.data.locations) == null ? void 0 : _a.find((loc) => loc.collection_id === locationId);
    if (location == null ? void 0 : location.displayName) {
      return `${acc}${location.displayName}, `;
    }
    return acc;
  }, "");
  return locationString ? locationString.slice(0, -2) : locationString;
};
export {
  formatVehicleLocation
};
